import iframeResizerChild from '@rio-cloud/iframe-resizer/child';

const LEGACY_MESSAGE_PREFIX = '[iFrameSizer]';
const LEGACY_CHILD_READY_MESSAGE = '[iFrameResizerChild]Ready';
const LEGACY_INIT_PART_COUNT_WITHOUT_MOUSE_EVENTS = 15;

// TODO: Remove this compatibility bridge after every host app has moved away from iframe-resizer-react 1.1.0.
export const upgradeLegacyInitMessage = (message: unknown) => {
    if (typeof message !== 'string' || !message.startsWith(LEGACY_MESSAGE_PREFIX)) {
        return;
    }

    const parts = message.slice(LEGACY_MESSAGE_PREFIX.length).split(':');
    const isMissingMouseEvents =
        parts.length === LEGACY_INIT_PART_COUNT_WITHOUT_MOUSE_EVENTS && (parts[2] === 'true' || parts[2] === 'false');

    if (!isMissingMouseEvents) {
        return;
    }

    // iframe-resizer 4.4 added the mouseEvents field expected by the new child parser.
    return `${message}:false`;
};

if (iframeResizerChild) {
    window.addEventListener('message', event => {
        if (event.source !== window.parent) {
            return;
        }

        const compatibleMessage = upgradeLegacyInitMessage(event.data);
        if (!compatibleMessage) {
            return;
        }

        window.dispatchEvent(
            new MessageEvent('message', {
                data: compatibleMessage,
                origin: event.origin,
                source: event.source,
            })
        );
    });

    // Older parents resend their initialization after this announcement. Modern parents ignore the string.
    window.parent.postMessage(LEGACY_CHILD_READY_MESSAGE, '*');
}

export default iframeResizerChild;
